import { ChildModel, ModelBase } from 'store/model-base';
import { StreetAddress } from 'store/user/models/address/street';
import { INSURANCE_PLAN_NAME, LiabilityType, UserState } from 'my-account/constants';
import { AccountType } from 'core/constants';

export class Account extends ModelBase {
    public static storeName: string = 'account';
    public static idAttribute: string = 'id';

    public id: Id;
    public firstName: string;
    public lastName: string;
    public cableAccountNumber: string;
    public state: UserState;
    public nextCycleDate: Date;
    public serviceAddress: StreetAddress;
    public user: PrimaryContact;
    public notificationContacts: NotificationContact;
    public level: AccountType;
    public canMoveLevel: boolean;
    public customerId: string;
    public liabilityType: LiabilityType;
    public authorizedBusinessRepresentativeContact: AuthorizedBusinessRepresentativeContact;
    public authGuid: string;
    public custGuid: string;
    public barId: string;
    public geoCode: string;
    public insuranceDetails: InsuranceDetails[];

    public isBusinessLiable: boolean;
    public isPersonalLiable: boolean;
    public isActive: boolean;
    public isNotSubscribed: boolean;
    public isNonPaySuspended: boolean;
    public isHotlined: boolean;
    public isGrandfathered: boolean;
    public isSegmentThree: boolean;
    public isSegmentFour: boolean;
    public isSegmentFive: boolean;
    public canNDEL: boolean;
    public displayName: string;
    public isSegmentTwo: boolean;
    public isAuthenticatedPreactivationUser: boolean;
    public isXTDP: boolean;
    public isXTDPPlus: boolean;

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'serviceAddress',
            model: StreetAddress
        }];
    }

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isActive = data.state === UserState.ACTIVE;
        data.isNotSubscribed = data.state === UserState.NOT_SUBSCRIBED;
        data.isNonPaySuspended = data.state === UserState.NON_PAY_SUSPENDED;
        data.isHotlined = data.state === UserState.HOTLINED;
        data.canNDEL = data.state === UserState.ACTIVE;
        data.canMoveLevel = (data.level === AccountType.LEVEL_2 || data.level === AccountType.LEVEL_3);
        data.isBusinessLiable = data.liabilityType === LiabilityType.BUSINESS_LIABLE;
        data.isPersonalLiable = data.liabilityType === LiabilityType.PERSONAL_LIABLE;

        const firstName: string = data.firstName || '';
        const lastName: string = data.lastName || '';

        data.displayName = firstName && lastName && `${firstName} ${lastName}`;
        data.isGrandfathered = data.level === AccountType.LEVEL_1;
        data.isSegmentTwo = data.level === AccountType.LEVEL_2;
        data.isSegmentThree = data.level === AccountType.LEVEL_3;
        data.isSegmentFour = data.level === AccountType.LEVEL_4;
        data.isSegmentFive = data.level === AccountType.LEVEL_5;
        data.isXTDP = data.insuranceDetails && data.insuranceDetails.some((detail: InsuranceDetails) => 
            detail.status === INSURANCE_PLAN_NAME.ACTIVE_PLAN && 
            detail.planName === INSURANCE_PLAN_NAME.XTDP
        );
        data.isXTDPPlus = data.insuranceDetails && data.insuranceDetails.some((detail: InsuranceDetails) => 
            detail.status === INSURANCE_PLAN_NAME.ACTIVE_PLAN && 
            detail.planName === INSURANCE_PLAN_NAME.XTDP_PLUS
        );
    
        return super.create<T>(data);
    }

    public setPreactivationUser(): boolean {
        return this.isAuthenticatedPreactivationUser = true;
    }
    
}
